import { render, staticRenderFns } from "./DBHome.vue?vue&type=template&id=f471ed5c"
import script from "./DBHome.vue?vue&type=script&lang=js"
export * from "./DBHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports